<ul>
  <li class="flex gap-2 mb-2">
    <plugins-checkbox
      inputId="selectAll"
      [formControl]="selectAllControl"
      icon="checkmark"
      [color]="settingsColor()"
      style="overflow: visible"
      [indeterminate]="isIndeterminateState?.() ?? false"
    />
    <label for="selectAll" class="field-label">
      <span class="field-key">{{
        'userDetails.userProfileFieldPicker.selectAll' | translate
      }}</span>
    </label>
  </li>
</ul>

<plugins-accordion
  [label]="'userDetails.userProfileFieldPicker.accordionLabel' | translate"
>
  <div class="accordion-content-wrapper">
    @if (description()) {
      <div class="ml-3 mb-3 accordion-description">
        {{ description() }}
      </div>
    }

    <plugins-profile-field-picker
      [color]="settingsColor()"
      [allowedFields]="profileFieldsAllowed()"
      [requiredFields]="profileFieldsRequired()"
      class="profile-field-picker"
      [formControl]="profileFieldsControl()"
    />
  </div>
</plugins-accordion>
